function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="19" height="19" viewBox="0 0 19 19" {...props}><defs><path id="svg1622289451a" d="M16.62 5.568c0 .178-.06.358-.179.509l-6.325 7.863a.813.813 0 0 1-1.263 0L2.56 6.11a.811.811 0 0 1 1.264-1.015l5.66 7.043 5.693-7.078a.81.81 0 0 1 1.441.508z" /></defs><g fill="none" fillRule="evenodd"><path d="M0 0h19v19H0z" /><use fill="currentColor" xlinkHref="#svg1622289451a" /></g></svg>;
});